import { GET_ADDFAQ_FAILED, GET_ADDFAQ_REQUESTED, GET_ADDFAQ_SUCCESS, GET_DELETEFAQ_FAILED, GET_DELETEFAQ_REQUESTED, GET_DELETEFAQ_SUCCESS, GET_FAQ_FAILED, GET_FAQ_REQUESTED, GET_FAQ_SECTION_FAILED, GET_FAQ_SECTION_REQUESTED, GET_FAQ_SECTION_SUCCESS, GET_FAQ_SUCCESS, GET_UPDATEFAQ_FAILED, GET_UPDATEFAQ_REQUESTED, GET_UPDATEFAQ_SUCCESS } from "resources/actionTypes";


const initialState = {
  userFaq: [],
  loading: false,
  error: null,
};
const initialStateAdd = {
  userAddFaq: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateFaq: [],
  loading: false,
  error: null
}
const initialStateDelete = {
  userDeleteFaq: [],
  loading: false,
  error: null
}

const intialStateSection = {
  userFaqSection : [],
  loading: false,
  error: null,
};

export function userFaq(state = initialState, action) {
  switch (action.type) {
    case GET_FAQ_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_FAQ_SUCCESS:
      return {
        ...state,
        loading: false,
        userFaq: action.userFaq,
      };
    case GET_FAQ_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddFaq(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDFAQ_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDFAQ_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddFaq: action.userAddFaq,
      };
    case GET_ADDFAQ_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateFaq(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATEFAQ_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEFAQ_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateFaq: action.userUpdateFaq,
      };
    case GET_UPDATEFAQ_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userDeleteFaq(state = initialStateDelete, action) {
  switch (action.type) {
    case GET_DELETEFAQ_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DELETEFAQ_SUCCESS:
      return {
        ...state,
        loading: false,
        userDeleteFaq: action.userDeleteFaq,
      };
    case GET_DELETEFAQ_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
export function userFaqSection(state = intialStateSection,action){
  switch(action.type){
    
      case GET_FAQ_SECTION_REQUESTED:
          return{
              ...state,
              loading:true,
          };
      case GET_FAQ_SECTION_SUCCESS:
          return{
              ...state,
              loading:false,
              userFaqSection: action.userFaqSection,
          };
      case GET_FAQ_SECTION_FAILED:
          return{
              ...state,
              loading:false,
              error:action.message,
          }
      default:
          return state;
  }
}
